const DateTimeHelpers = {
  getTodayStr() {
    const now = new Date();
    const d = now.getDate();
    const m = now.getMonth() + 1;
    const y = now.getFullYear();
    return `${y}/${m <= 9 ? `0${m}` : m}/${d <= 9 ? `0${d}` : d}`;
  },
  convertDateToMDY(date) {
    const dateParts = date.split('/');
    return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
  },
  //deprecated against `convertDateToIsoDMY`
  convertDateToDMY(date) {
    if (date == null) {
      return '';
    }
    const dObj = date instanceof Date ? date : new Date(date);
    if (Number.isNaN(dObj.getTime())) return '';
    const d = dObj.getDate();
    const m = dObj.getMonth() + 1;
    const y = dObj.getFullYear();
    return `${d <= 9 ? `0${d}` : d}/${m <= 9 ? `0${m}` : m}/${y}`;
  },
  convertDateToIsoDMY(dateString) {
    if (dateString == null) return '';
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return '';
    const d = date.getUTCDate();
    const m = date.getUTCMonth() + 1;
    const y = date.getUTCFullYear();
    return `${d <= 9 ? `0${d}` : d}-${m <= 9 ? `0${m}` : m}-${y}`;
  },
  convertTo12HourTime(dateString) {
    if (dateString == null) return '';
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return '';
    if (typeof dateString === 'string' && !dateString.includes(':')) return '';
    const timeOptions = {
      timeZone: 'UTC',
      hour12: true,
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    };
    return date.toLocaleTimeString(undefined, timeOptions).toUpperCase();
  },
  get12HourTime(dateString) {
    if (dateString == null) return '';
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return '';
    if (typeof dateString === 'string' && !dateString.includes(':')) return '';
    return date
      .toLocaleTimeString('en-US', {
        hour12: true,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
      .replace(/:/g, '.')
      .toUpperCase();
  },
  formatUTCDateTime(date) {
    if (date == null) return '';
    const formattedDate = this.convertDateToIsoDMY(date);
    const formattedTime = this.convertTo12HourTime(date);
    if (!formattedDate) return '';
    if (!formattedTime) return formattedDate;
    return `${formattedDate} ${formattedTime}`;
  },
  formatDateTime(date) {
    if (date == null) return '';
    const formattedDate = this.convertDateToIsoDMY(date);
    const formattedTime = this.get12HourTime(date);
    if (!formattedDate) return '';
    if (!formattedTime) return formattedDate;
    return `${formattedDate} ${formattedTime}`;
  },
  covertDateToJsDate(date) {
    const dateParts = date.toString().split('/');
    const dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
    return dateObject.toISOString();
  },
  getDate(dateString) {
    return this.convertDateToIsoDMY(dateString);
  },
  getTime(dateString) {
    if (dateString == null) return '';
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return '';
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const seconds = date.getUTCSeconds();
    return `${hours}:${minutes}:${seconds}`;
  },
  getTodayStrInYMD() {
    const now = new Date();
    return this.getDateYMD(now);
  },
  getYesterdayStr() {
    const now = new Date();
    now.setDate(now.getDate() - 1);
    return this.getDateYMD(now);
  },
  getWeekStr() {
    const now = new Date();
    now.setDate(now.getDate() - 7);
    return this.getDateYMD(now);
  },
  getMonthStr() {
    const now = new Date();
    now.setMonth(now.getMonth() - 1);
    return this.getDateYMD(now);
  },
  getSixMonthStr() {
    const now = new Date();
    now.setMonth(now.getMonth() - 6);
    return this.getDateYMD(now);
  },
  getDateYMD(date) {
    const d = date.getDate();
    const m = date.getMonth() + 1;
    const y = date.getFullYear();
    return `${y}-${m <= 9 ? `0${m}` : m}-${d <= 9 ? `0${d}` : d}`;
  },
  formatServerTimeSegment(timeString) {
    const [hours, minutes, seconds] = timeString.split(':');
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(seconds);
    const timeOptions = {
      hour12: true,
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    };
    return date.toLocaleTimeString(undefined, timeOptions).toUpperCase();
  },
  startOfDay(dateString) {
    const startDate = new Date(dateString);
    startDate.setUTCHours(0, 0, 0, 0);
    return startDate.toISOString();
  },
  endOfDay(dateString) {
    const endDate = new Date(dateString);
    endDate.setUTCHours(23, 59, 59, 999);
    return endDate.toISOString();
  },
  reportDateLimit(startDate, endDate) {
    const dateDifference =
      (endDate.getFullYear() - startDate.getFullYear()) * 12 + (endDate.getMonth() - startDate.getMonth());

    return dateDifference > 3;
  },
  getFiveDateEarlier() {
    const date = new Date();
    date.setDate(date.getDate() - 4);
    return date;
  },
  getTimezoneOffsetDate(date) {
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  },
  getUtcToLocalDate(date) {
    if (!date) return new Date();
    const d = new Date(date);
    return new Date(
      d.getUTCFullYear(),
      d.getUTCMonth(),
      d.getUTCDate(),
      d.getUTCHours(),
      d.getUTCMinutes(),
      d.getUTCSeconds(),
      d.getUTCMilliseconds()
    );
  },
  isSameDate(date1, date2) {
    if (!date1 || !date2) return false;
    return new Date(date1).toDateString() === new Date(date2).toDateString();
  },
  isDatePassed(date1, date2 = new Date()) {
    if (!date1 || !date2) return false;
    const d1 = new Date(date1);
    d1.setHours(0, 0, 0, 0);
    const d2 = new Date(date2);
    d2.setHours(0, 0, 0, 0);
    return d1 < d2;
  },
  formatDMYTo12Hour(dateTimeString) {
    if (!dateTimeString || !dateTimeString.includes(' ')) return dateTimeString;
    const [datePart, timePart] = dateTimeString.split(' ');
    const [hours, minutes, seconds] = timePart.split(':');
    const date = new Date();
    date.setHours(parseInt(hours, 10));
    date.setMinutes(parseInt(minutes, 10));
    date.setSeconds(parseInt(seconds, 10));
    const timeOptions = {
      hour12: true,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    };
    const formattedTime = date.toLocaleTimeString('en-US', timeOptions);
    return `${datePart} ${formattedTime}`;
  },
  getStartOfMonthInYMD() {
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    return this.getDateYMD(firstDay);
  },
  getExpiryStatus(expiryDateStr, expiredLabel = 'Expired', remainingLabel = 'remaining') {
    if (!expiryDateStr) return { text: '-', isExpired: false };
    const expiryDate = new Date(expiryDateStr);
    const now = new Date();
    const diff = expiryDate - now;

    if (diff <= 0) return { text: expiredLabel, isExpired: true };

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    let remainingStr = '';
    if (days > 0) remainingStr += `${days}d `;
    if (hours > 0) remainingStr += `${hours}h `;
    if (minutes > 0) remainingStr += `${minutes}m `;

    return { text: `${remainingStr.trim()} ${remainingLabel}`, isExpired: false };
  },
};

export default DateTimeHelpers;
